"use client";
import Script from "next/script";

interface FacebookPixelScriptProps {
  pixelId: string;
}

export default function FacebookPixelScript({
  pixelId,
}: FacebookPixelScriptProps) {
  return (
    <>
      <Script
        id="facebook-pixel"
        strategy="afterInteractive"
        src="https://connect.facebook.net/en_US/fbevents.js"
        onLoad={() => {
          if (window.fbq) {
            window.fbq("init", pixelId);
            window.fbq("track", "PageView");
          }
        }}
        onError={() => {
          console.warn("Facebook Pixel script blocked or failed to load");
        }}
      />

      {/* Fallback initialization */}
      <Script
        id="facebook-pixel-init"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
            if (!window.fbq) {
              window.fbq = function() {
                console.log('FB Pixel blocked - event would be:', arguments);
              };
            }
          `,
        }}
      />
    </>
  );
}
